import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GetBackCountsInProgressCount, GetFirstBackCountID } from 'src/app/shared/states/audits/audits.actions';
import { AuditsState } from 'src/app/shared/states/audits/audits.state';

@UntilDestroy()
@Component({
  selector: 'app-back-count-badge',
  templateUrl: './back-count-badge.component.html',
  styleUrls: ['./back-count-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackCountBadgeComponent implements OnInit {
  @Select(AuditsState.backCountsCount) backCountsCount$: Observable<number>;

  backCountsCount: number;
  /**
   *
   */
  constructor(
    private store: Store,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetBackCountsInProgressCount());

    this.backCountsCount$.pipe(untilDestroyed(this)).subscribe((val) => {
      this.backCountsCount = val;
      this.cdr.markForCheck();
    });
  }

  onClick(): void {
    if (this.backCountsCount === 1) {
      this.store
        .dispatch(new GetFirstBackCountID())
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          const id = this.store.selectSnapshot(AuditsState.firstBackCountID);
          if(id) {
            this.redirectToAudit(id)
          } else {
            this.redirectToAudits();
          }
        });
    }
    else {
      this.redirectToAudits();
    }
  }

  private redirectToAudit(id: string): void {
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['audits/details', id], {state : {
      navigatedFrom: this.router.url 
    }
   });
  }

  private redirectToAudits(): void {
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['audits'], {
      state: {
        prefilterBackCounts: true,
      },
    });
  }
}


